import isEqual from "lodash.isequal"
import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

import { preferencesSuccess } from "../../User/redux/user.actions"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getRequestsIntegrationsRequest: ["payload"], // payload: { params }
  getRequestsIntegrationsSuccess: ["payload"], // payload: { data }

  deleteRequestsIntegrationRequest: ["payload"], // payload: { id }
  deleteRequestsIntegrationSuccess: ["payload"], // payload: { data }

  requestsIntegrationsFailure: ["payload"], // payload: { errors }

  clearRequestsIntegrationsFilters: null,
  requestsIntegrationsSetProp: ["key", "value"],

  getRequestsIntegrationsExportRequest: ["payload"], // payload: { business_id }
  getRequestsIntegrationsExportSuccess: ["payload"], // payload: { url }
  getRequestsIntegrationsExportFailure: ["payload"], // payload: { errors }

  logout: null
})

export const RequestsIntegrationsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

const columnsAdmin = [
  { field_id: "created_timestamp", label: "Request date", active: true },
  { field_id: "integration_url", label: "Integration URL", active: true },
  { field_id: "description", label: "Description", active: true },

  { field_id: "user_full_name", label: "User full name", active: true },
  { field_id: "user_email", label: "User email", active: true },
  { field_id: "business_account", label: "Business account", active: true },
  { field_id: "business_url", label: "Business URL", active: true },

  { field_id: "admin_comment", label: "Comment", active: true },
  { field_id: "admin_screenshots", label: "Screenshots", active: true }
]

export const INITIAL_STATE = Immutable({
  fetching: false,
  result: {
    count: 0,
    next: null,
    previous: null,
    results: []
  },

  defaultColumnsAdmin: [...columnsAdmin],
  columnsAdmin: [...columnsAdmin],

  filtersLastUpd: null,
  filters: {
    created_timestamp: null,
    integration_url: [],
    description: [],
    user_full_name: [],
    user_email: [],
    business_account: [],
    business_url: [],
    exclude_fields: [],
    admin_comment: [],
    admin_screenshots: "all"
  },

  visibleFiltersAdmin: { user_email: true, user_full_name: true, business_account: true },

  exportFetching: false,
  exportResult: null
})

/* ------------- Selectors ------------- */
export const selectAreFiltersDefault = (state) =>
  isEqual(state.requestsIntegrations.filters, INITIAL_STATE.filters)

/* ------------- Functions for reducer cases ------------- */
const getRequestsIntegrationsRequest = (state) => state.merge({ fetching: true })
const getRequestsIntegrationsSuccess = (state, { payload: result }) => {
  if (result.results) {
    return state.merge({ fetching: false, result })
  } else {
    return state.merge({
      fetching: false,
      result: {
        count: result?.length || 0,
        results: result
      }
    })
  }
}

const deleteRequestsIntegrationRequest = (state) => state.merge({ fetching: true })
const deleteRequestsIntegrationSuccess = (state, { payload: integration }) => {
  const results = state.result?.results?.filter((el) => el.id !== integration?.id)
  return state.merge({
    fetching: false,
    result: {
      count: state.result?.count - 1,
      results: results
    }
  })
}

const requestsIntegrationsFailure = (state) => state.merge({ fetching: false })

export const requestsIntegrationsSetProp = (state, { key, value }) => {
  const obj = {}
  if (["filters", "visibleFilters", "visibleFiltersAdmin"]?.includes(key)) {
    if (key === "filters") obj.filtersLastUpd = new Date().getTime()
    obj[key] = { ...state?.[key], ...value }
  } else {
    obj[key] = value
  }
  return state.merge(obj)
}

export const clearRequestsIntegrationsFilters = (state) => {
  return state.merge({ filters: INITIAL_STATE.filters })
}

const getRequestsIntegrationsExportRequest = (state) => state.merge({ exportFetching: true })
const getRequestsIntegrationsExportSuccess = (state, { payload: exportResult }) =>
  state.merge({
    exportFetching: false,
    exportResult
  })
const getRequestsIntegrationsExportFailure = (state) => state.merge({ exportFetching: false })

const logout = (state) => {
  return state.merge({
    ...INITIAL_STATE,
    filters: state.filters,
    columnsAdmin: state.columnsAdmin,
    visibleFiltersAdmin: state.visibleFiltersAdmin
  })
}

// Bump when the shape of the saved `{ version, filters, columnsAdmin, visibleFiltersAdmin }`
// payload changes.
export const REQUESTS_INTEGRATIONS_PREFERENCES_VERSION = 1

const applyPreferences = (state, { payload }) => {
  const preference = payload?.["requests-integrations"]?.data
  if (!preference || preference.version !== REQUESTS_INTEGRATIONS_PREFERENCES_VERSION) return state
  if (!preference.filters || !preference.columnsAdmin || !preference.visibleFiltersAdmin)
    return state

  return state.merge({
    filters: preference.filters,
    columnsAdmin: preference.columnsAdmin,
    visibleFiltersAdmin: preference.visibleFiltersAdmin
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_REQUESTS_INTEGRATIONS_REQUEST]: getRequestsIntegrationsRequest,
  [Types.GET_REQUESTS_INTEGRATIONS_SUCCESS]: getRequestsIntegrationsSuccess,

  [Types.DELETE_REQUESTS_INTEGRATION_REQUEST]: deleteRequestsIntegrationRequest,
  [Types.DELETE_REQUESTS_INTEGRATION_SUCCESS]: deleteRequestsIntegrationSuccess,

  [Types.REQUESTS_INTEGRATIONS_FAILURE]: requestsIntegrationsFailure,

  [Types.CLEAR_REQUESTS_INTEGRATIONS_FILTERS]: clearRequestsIntegrationsFilters,

  [Types.REQUESTS_INTEGRATIONS_SET_PROP]: requestsIntegrationsSetProp,

  [Types.GET_REQUESTS_INTEGRATIONS_EXPORT_REQUEST]: getRequestsIntegrationsExportRequest,
  [Types.GET_REQUESTS_INTEGRATIONS_EXPORT_SUCCESS]: getRequestsIntegrationsExportSuccess,
  [Types.GET_REQUESTS_INTEGRATIONS_EXPORT_FAILURE]: getRequestsIntegrationsExportFailure,

  [Types.LOGOUT]: logout,

  [preferencesSuccess.type]: applyPreferences
})
